import React from 'react';
import { Link } from 'react-router-dom';
import { usePermissionViewModel } from '../../pages/admin/permissions/viewmodel/permission-viewmodel';

const UserProfile = ({ user, getUserAvatar, handleLogout }) => {
  const { hasPermission } = usePermissionViewModel('profil');
  return (
    <div className="bg-gradient-to-r from-[#0a201e] to-[#112f2c] backdrop-blur-sm rounded-xl py-3 px-4 shadow-lg ring-1 ring-black/10 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-40 h-40 bg-emerald-500/5 rounded-full blur-2xl -translate-y-20 translate-x-20"></div>
      <div className="absolute bottom-0 left-0 w-40 h-40 bg-emerald-600/5 rounded-full blur-2xl translate-y-20 -translate-x-20"></div>

      <div className="flex items-center relative z-10">
        <div className="flex-shrink-0 relative">
          <div className="absolute inset-0 rounded-lg bg-gradient-to-br from-emerald-400/30 to-teal-500/30 blur-sm"></div>
          <img
            className="h-11 w-11 rounded-lg border-2 border-emerald-500/50 object-cover relative z-10 shadow-lg"
            src={getUserAvatar()}
            alt={`${user?.firstName || ''} ${user?.lastName || ''}`}
            onError={(e) => {
              e.target.src = "https://ui-avatars.com/api/?name=User&background=174540&color=fff";
            }}
          />
          <div className="absolute -bottom-1 -right-1 h-3 w-3 bg-emerald-500 rounded-full border-2 border-[#0d2926] z-20 shadow-emerald-500/40 shadow-sm"></div>
        </div>
        <div className="ml-3 flex-1">
          <div className="flex items-center justify-between">
            <p className="text-sm font-medium text-white">{`${user?.fullName || ''}`}</p>
            <div className="bg-emerald-600/20 h-6 w-6 rounded-full flex items-center justify-center ring-4 ring-emerald-600/10">
              <svg className="h-3 w-3 text-emerald-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
          </div>
          <div className="flex items-center">
            <p className="text-xs text-gray-400 truncate mr-1.5">{user?.email || 'email@exemple.com'}</p>
            <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100/10 text-emerald-400">
              Admin
            </span>
          </div>
        </div>
      </div>
      <div className="h-px w-full bg-gradient-to-r from-transparent via-emerald-500/20 to-transparent my-3"></div>
      <div className="flex justify-between text-xs relative z-50">
{  (hasPermission('read')|| hasPermission('write'))&&     <Link
          to="/profile"
          className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-1 relative z-50"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 0016 0 8 8 0 0016 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 005 10a6 6 0 0012 0c0-.358-.035-.708-.101-1.047A5 5 0 0010 11z" clipRule="evenodd" />
          </svg>
          <span>Profil</span>
        </Link>
}  
{   (hasPermission("read",'paramètres')|| hasPermission("write",'paramètres') )&&  <Link
          to="/admin/settings"
          className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-1 relative z-50"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
          </svg>
          Réglages
        </Link>
}        <button
          onClick={handleLogout}
          className="text-gray-400 hover:text-red-400 transition-colors duration-200 flex items-center gap-1 relative z-50"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
          </svg>
          Déconnexion
        </button>
      </div>
    </div>
  );
};

export default UserProfile;